import { render, staticRenderFns } from "./judicialAssistList.vue?vue&type=template&id=6d218ec2&scoped=true"
import script from "./judicialAssistList.vue?vue&type=script&lang=js"
export * from "./judicialAssistList.vue?vue&type=script&lang=js"
import style0 from "./judicialAssistList.vue?vue&type=style&index=0&id=6d218ec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d218ec2",
  null
  
)

export default component.exports